import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Eye, Download, Share2, Trash2, FolderOpen, Shield } from 'lucide-react';
import { TFileItem } from '@/data/types';

interface FileDropdownProps {
  file: TFileItem;
  onClose: () => void;
  canDownloadFile: (file: TFileItem) => boolean;
  onPreview: (file: TFileItem) => void;
  onDownload: (file: TFileItem) => void;
  onMove: (file: TFileItem) => void;
  onDelete: (file: TFileItem) => void;
  onAbacEdit: () => void;
}

const FileDropdown: React.FC<FileDropdownProps> = React.memo(
  ({ file, onClose, canDownloadFile, onPreview, onDownload, onMove, onDelete, onAbacEdit }) => {
    const handleShare = () => {
      // Handle share functionality
      onClose();
    };

    const handleMove = () => {
      onMove(file);
      onClose();
    };

    const handleDelete = () => {
      onDelete(file);
      onClose();
    };

    const handleAbacEdit = () => {
      onAbacEdit();
      onClose();
    };

    return (
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: -10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: -10 }}
          transition={{ duration: 0.15 }}
          className="absolute top-8 right-0 z-50 min-w-48 rounded-xl border border-gray-200 bg-white p-2 shadow-lg"
          onClick={(e) => e.stopPropagation()}
          data-dropdown
        >
          <button
            onClick={() => {
              onPreview(file);
              onClose();
            }}
            className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-gray-700 transition-colors hover:bg-gray-50"
          >
            <Eye className="h-4 w-4" />
            Προεπισκόπηση
          </button>

          {canDownloadFile(file) && (
            <button
              onClick={() => {
                onDownload(file);
                onClose();
              }}
              className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-gray-700 transition-colors hover:bg-gray-50"
            >
              <Download className="h-4 w-4" />
              Λήψη
            </button>
          )}

          <button
            onClick={handleMove}
            className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-gray-700 transition-colors hover:bg-gray-50"
          >
            <FolderOpen className="h-4 w-4" />
            Μετακίνηση σε
          </button>

          <button
            onClick={handleAbacEdit}
            className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-gray-700 transition-colors hover:bg-gray-50"
          >
            <Shield className="h-4 w-4" />
           Δικαιώματα
          </button>

          <div className="my-1 h-px bg-gray-200" />

          {/* <button
          onClick={handleShare}
          className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
        >
          <Share2 className="h-4 w-4" />
          Κοινή χρήση
        </button> */}

          <button
            onClick={handleDelete}
            className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-red-600 transition-colors hover:bg-red-50"
          >
            <Trash2 className="h-4 w-4" />
            Διαγραφή
          </button>
        </motion.div>
      </AnimatePresence>
    );
  },
);

FileDropdown.displayName = 'FileDropdown';

export default FileDropdown;